import { useState } from 'react';
import FloatingSupportButton from './floating-support-button';
import FloatingSupportForm from './floating-support-form';

const FloatingSupport = () => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <FloatingSupportButton onClick={handleOpen} />
      <FloatingSupportForm open={open} onClose={handleClose} />
    </>
  );
};

export default FloatingSupport;
